<template>
  <div>
    <Calendar language="fr"
              :display-week-number="true"
              :data-source="weeksSelect"
              render-style="background"
              class="calendar"
              id="calendar"
              @click-day="selectDay">
    </Calendar>
  </div>
</template>

<script>

import moment from 'moment';
import Calendar from 'v-year-calendar';
import 'v-year-calendar/locales/v-year-calendar.fr';
import getAnneeSemaineFromDate from '@/services/general/getAnneeSemaineFromDate';

export default {
  props: {
    weeksSelect: {
      type: Array,
      required: true,
    },
  },
  components: {
    Calendar,
  },
  methods: {
    selectDay(event) {
      const dateSelect = event.date;
      const anneeSemaine = getAnneeSemaineFromDate(dateSelect);
      const indexWeek = this.weeksSelect.findIndex((week) => {
        return week.anneeSemaine === anneeSemaine;
      });
      if (indexWeek !== -1) this.weeksSelect.splice(indexWeek, 1);
      else {
        const dateDebut = moment(dateSelect).startOf('week').toDate();
        const dateFin = moment(dateSelect).endOf('week').toDate();
        this.weeksSelect.push({
          startDate: dateDebut,
          endDate: dateFin,
          anneeSemaine: anneeSemaine,
          color: '#3598DC',
        });
      }
    },
    scrollToDate() {
      const calendarElement = document.querySelector('#calendar');
      const moisCourant = moment().format('MM') - 1;
      const coordCalendarElement = calendarElement.getBoundingClientRect();
      const calendarMonthElement = calendarElement.querySelector('div[data-month-id="' + moisCourant + '"]');
      const coord = calendarMonthElement.getBoundingClientRect();

      const scrollOptions = {
        left: 0,
        top: coord.top - coordCalendarElement.top - 60,
        behavior: 'smooth',
      };
      calendarElement.scrollBy(scrollOptions);
      const titreMois = calendarMonthElement.querySelector('th[class="month-title"]');
      titreMois.className += ' month-title-courant';
    },
  },
  mounted() {
    this.scrollToDate();
  },
};

</script>
